import React, { FC, useState } from 'react';

import { ValuationTypes } from '@constants/common';

import AddButton from '../add-button/AddButton';
import AddRoundModal from '../../containers/AddRoundModal';
import useGetRounds from '../../hooks/useGetRounds';

const ValuationHeader: FC<{
  disableEdit?: boolean;
  viewMode?: boolean;
  dealId?: string;
}> = ({ disableEdit = false, dealId }) => {
  const [isCreateRoundModalOpen, setCreateRoundModalOpen] = useState(false);
  const { data } = useGetRounds();

  const roundDetailsList =
    data?.rounds
      ?.filter(round => round.valuation_type === ValuationTypes.PRICED)
      .map(round => round.round_name) || [];

  const onClickCreateNewRound = () => {
    setCreateRoundModalOpen(true);
  };

  const onCloseModal = () => {
    setCreateRoundModalOpen(false);
  };
  return (
    <div className="flex items-center ">
      <span className="mr-4 text-xl font-semibold">Valuation</span>
      {!disableEdit && (
        <AddButton
          handleButtonClick={onClickCreateNewRound}
          label="CREATE NEW ROUND"
        />
      )}
      {isCreateRoundModalOpen && (
        <AddRoundModal
          isOpen={isCreateRoundModalOpen}
          handleCloseModal={onCloseModal}
          valuationType={ValuationTypes.PRICED}
          existingRoundNames={roundDetailsList}
          dealId={dealId}
          shouldShowDealMarkup={roundDetailsList.length > 0}
        />
      )}
    </div>
  );
};

export default ValuationHeader;
